import React, { useContext, useState } from "react";
import { PropTypes } from "prop-types";

import CustomModal from "../../../react_utils/modals/CustomModal";
import Heatmap from "../../../react_utils/plots/Heatmap";
import { round } from "../../../shared/utils/utils";
import { Box, CircularProgress } from "@mui/material";
import useClientRequestHeatmap from "../../../shared/hooks/client/useClientRequestHeatmap";
import { AuthContext } from "../../../shared/contexts/AuthContext";

export default function ClientRequestHeatmapModal({ client, modalProps = {} }) {
  const { apiClient } = useContext(AuthContext);
  const [isFocused, setIsFocused] = useState(false);

  const { matrix, ticks } = useClientRequestHeatmap(
    client,
    apiClient,
    isFocused,
  );

  const onToggle = (isOpen) => {
    setIsFocused(isOpen);
    modalProps.onToggle?.(isOpen);
  };

  const xTicks = ticks.x;
  const yTicks = ticks.y;
  return (
    <CustomModal
      size="lg"
      title={"Verbindungsqualität"}
      {...modalProps}
      onToggle={onToggle}
    >
      {matrix ? (
        <Heatmap
          height={600}
          minValue={0}
          maxValue={100}
          matrix={matrix}
          xTicks={xTicks}
          yTicks={yTicks}
          tooltipText={(value, xIdx, yIdx) =>
            `${xTicks[xIdx]} ${yTicks[yIdx]}: ${round(value)}`
          }
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 5,
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      )}
    </CustomModal>
  );
}

ClientRequestHeatmapModal.propTypes = {
  client: PropTypes.object,
  modalProps: PropTypes.object,
  resetParent: PropTypes.func,
};
